var React = require('react');

function CalendarLocation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 4C10 1.79086 8.20914 0 6 0C3.79086 0 2 1.79086 2 4C2 6 3.33333 8.66667 6 12C8.66667 8.66667 10 6 10 4ZM4.5 4C4.5 3.17157 5.17157 2.5 6 2.5C6.82843 2.5 7.5 3.17157 7.5 4C7.5 4.82843 6.82843 5.5 6 5.5C5.17157 5.5 4.5 4.82843 4.5 4Z","fill":"currentColor"}));
}

CalendarLocation.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarLocation;

CalendarLocation.default = CalendarLocation;
